module.exports = __webpack_public_path__ + "static/media/file-search.4158235c.svg";